import JwtService from "@/services/jwt.service"
import ApiService from "@/services/api.service"
import {capitalize} from "vue"

const sendReceiptToMessenger = async (clinic, receiptId, noty, i18n, messenger = 'whatsapp') => {
	let link = JwtService.getPrintPrelink(clinic)
	const url = link+'/receipt/'+receiptId+`?sendVia${capitalize(messenger)}=1`
	try {
		const res = await ApiService.get(url)
		const success = res?.data === 0
		if(success) {
			noty.info(i18n('sent'))
		} else {
			noty.error(i18n('error_message'))
		}
	} catch (e) {
		console.log(e)
	}
}

export { sendReceiptToMessenger }
